import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.extra.space.Organization.JointUseCalculationMode,
    graphql.schema.OrgJointUseCalculationMode
  >({
    [ents.extra.space.Organization.JointUseCalculationMode.Manual]:
      graphql.schema.OrgJointUseCalculationMode.Manual,
    [ents.extra.space.Organization.JointUseCalculationMode.Inherit]:
      graphql.schema.OrgJointUseCalculationMode.Inherit,
    [ents.extra.space.Organization.JointUseCalculationMode.Salary]:
      graphql.schema.OrgJointUseCalculationMode.Salary,
  }),
  graphql.transformers.OUT.enumeration<
    graphql.schema.OrgJointUseCalculationMode,
    ents.extra.space.Organization.JointUseCalculationMode
  >({
    [graphql.schema.OrgJointUseCalculationMode.Manual]:
      ents.extra.space.Organization.JointUseCalculationMode.Manual,
    [graphql.schema.OrgJointUseCalculationMode.Inherit]:
      ents.extra.space.Organization.JointUseCalculationMode.Inherit,
    [graphql.schema.OrgJointUseCalculationMode.Salary]:
      ents.extra.space.Organization.JointUseCalculationMode.Salary,
  }),
)
